import { create, tsx } from '@dojo/framework/core/vdom';
import { Outlet } from '@dojo/framework/routing/Outlet';
import Footer from './widgets/Footer';
import Header from './widgets/Header';
import About from './widgets/pages/About';
import AutomatedTesting from './widgets/pages/AutomatedTesting';
import Careers from './widgets/pages/Careers';
import Contact from './widgets/pages/Contact';
import ContactThankyou from './widgets/pages/ContactThankyou';
import Expertise from './widgets/pages/Expertise';
import Home from './widgets/pages/Home';
import OpenSource from './widgets/pages/OpenSource';
import Privacy from './widgets/pages/Privacy';
import Services from './widgets/pages/Services';
import Work from './widgets/pages/Work';
import * as css from './App.m.css';
import CaseStudyFannie from './widgets/pages/CaseStudyFannie';
import CaseStudyMarriott from './widgets/pages/CaseStudyMarriott';
import CaseStudyBuilt from './widgets/pages/CaseStudyBuilt';
import CaseStudySocialRVComplete from './widgets/pages/case-study/SocialRVComplete';
import CaseStudySocialRVLife from './widgets/pages/case-study/SocialRVLife';
import CaseStudySocialTripWizard from './widgets/pages/case-study/SocialTripWizard';
import CaseStudyCentric from './widgets/pages/CaseStudyCentric';
import CrossPlatformDevelopment from './widgets/pages/CrossPlatformDevelopment';
import OpenSourceDojo from './widgets/pages/OpenSourceDojo';
import OpenSourceIntern from './widgets/pages/OpenSourceIntern';
import OpenSourceTypescript from './widgets/pages/OpenSourceTypescript';
import OpenSourceDojoToolkit from './widgets/pages/OpenSourceDojoToolkit';
import OpenSourceDgrid from './widgets/pages/OpenSourceDgrid';
import PerformanceTesting from './widgets/pages/PerformanceTesting';
import QualityAssurance from './widgets/pages/QualityAssurance';
import GDPRBanner from './widgets/GDPRBanner';
import Error404 from './widgets/pages/Error404';
import { BlogList } from './widgets/pages/BlogList';
import { Blog } from './widgets/pages/Blog';
import Category from './widgets/pages/Category';
import Series from './widgets/pages/Series';
import SearchResults from './widgets/pages/SearchResults';
import StrategySession from './widgets/pages/StrategySession';
import JavaScriptDevelopment from './widgets/pages/JavascriptDevelopment';
import FullStackDevelopment from './widgets/pages/FullStackDevelopment';
import CustomSoftwareDevelopment from './widgets/pages/CustomSoftwareDevelopment';
import DevOpsSolutions from './widgets/pages/DevOpsSolutions';
import DojoDevelopment from './widgets/pages/DojoDevelopment';
import EnterpriseArchitecture from './widgets/pages/EnterpriseArchitecture';
import EnterpriseSoftwareDevelopment from './widgets/pages/EnterpriseSoftwareDevelopment';
import EnterpriseCloudServices from './widgets/pages/EnterpriseCloudServices';
import EnterpriseTechnologyStrategy from './widgets/pages/EnterpriseTechnologyStrategy';
import EnterpriseUX from './widgets/pages/EnterpriseUX';
import { JobPost } from './widgets/JobPost';
import RapidPrototyping from './widgets/pages/RapidPrototyping';
import ReactDevelopment from './widgets/pages/ReactDevelopment';
import SoftwareArchitecture from './widgets/pages/SoftwareArchitecture';
import SoftwareModernization from './widgets/pages/SoftwareModernization';
import TypeScriptDevelopment from './widgets/pages/TypeScriptDevelopment';
import UXDesign from './widgets/pages/UXDesign';
import VueDevelopment from './widgets/pages/VueDevelopment';
import WebApplicationDevelopment from './widgets/pages/WebApplicationDevelopment';
import AngularDevelopment from './widgets/pages/AngularDevelopment';
import NodeDevelopment from './widgets/pages/NodeDevelopment';
import PerformanceOptimization from './widgets/pages/PerformanceOptimization';
import UIDesign from './widgets/pages/UIDesign';

const factory = create();

export const App = factory(function App() {
	return (
		<div classes={css.root}>
			<Header />
			<main>
				<div id="sentinel"></div>
				<Outlet
					id="main"
					matcher={(defaultMatchers, matchDetailsMap) => {
						const blogMatch = matchDetailsMap.get('blog');
						const blogPageOrPostMatch = matchDetailsMap.get('blogPage');
						if (blogMatch) {
							defaultMatchers.blog = blogMatch.isExact();
						}

						if (blogPageOrPostMatch) {
							const isPage = !!Number(blogPageOrPostMatch.params.slugOrPage);
							defaultMatchers.blogPage = isPage;
							defaultMatchers.blogPost = !isPage;
						}

						return defaultMatchers;
					}}
				>
					{{
						about: <About />,
						careerPage: ({ params: { jobId } }) => <JobPost id={jobId} />,
						careers: ({ isExact }) => {
							return isExact() && <Careers />;
						},
						contact: <Contact />,
						strategySession: <StrategySession />,
						contactThankyou: <ContactThankyou />,
						expertise: ({ isExact }) => {
							return isExact() && <Expertise />;
						},
						home: <Home />,
						opensource: <OpenSource />,
						opensourceDojo: <OpenSourceDojo />,
						opensourceIntern: <OpenSourceIntern />,
						opensourceTypescript: <OpenSourceTypescript />,
						opensourceDojoToolkit: <OpenSourceDojoToolkit />,
						opensourceDgrid: <OpenSourceDgrid />,
						privacy: <Privacy />,
						services: ({ isExact }) => {
							return isExact() && <Services />;
						},
						work: <Work />,
						casestudyFannie: <CaseStudyFannie />,
						casestudyMarriott: <CaseStudyMarriott />,
						casestudyBuilt: <CaseStudyBuilt />,
						casestudySocialRVComplete: <CaseStudySocialRVComplete />,
						casestudySocialRVLife: <CaseStudySocialRVLife />,
						casestudySocialTripWizard: <CaseStudySocialTripWizard />,
						expertiseAngular: <AngularDevelopment />,
						expertiseDojo: <DojoDevelopment />,
						expertiseJavascript: <JavaScriptDevelopment />,
						expertiseFullStack: <FullStackDevelopment />,
						expertiseNode: <NodeDevelopment />,
						expertiseReact: <ReactDevelopment />,
						expertiseTypeScript: <TypeScriptDevelopment />,
						expertiseVue: <VueDevelopment />,
						servicesAutomatedTesting: <AutomatedTesting />,
						servicesCrossPlatformDevelopment: <CrossPlatformDevelopment />,
						servicesCustomSoftwareDevelopment: <CustomSoftwareDevelopment />,
						servicesEnterpriseArchitecture: <EnterpriseArchitecture />,
						servicesEnterpriseDevOpsSolutions: <DevOpsSolutions />,
						servicesEnterpriseSoftwareDevelopment: <EnterpriseSoftwareDevelopment />,
						servicesEnterpriseCloudServices: <EnterpriseCloudServices />,
						servicesEnterpriseTechnologyStrategy: <EnterpriseTechnologyStrategy />,
						servicesEnterpriseUX: <EnterpriseUX />,
						servicesPerformanceOptimization: <PerformanceOptimization />,
						servicesPerformanceTesting: <PerformanceTesting />,
						servicesQualityAssurance: <QualityAssurance />,
						servicesRapidPrototyping: <RapidPrototyping />,
						servicesSoftwareArchitecture: <SoftwareArchitecture />,
						servicesUIDesign: <UIDesign />,
						servicesUXDesign: <UXDesign />,
						servicesSoftwareModernization: <SoftwareModernization />,
						servicesWebApplicationDevelopment: <WebApplicationDevelopment />,
						casestudyCentric: <CaseStudyCentric />,
						category: ({ params: { slug } }) => <Category slug={slug} />,
						series: ({ params: { slug } }) => <Series slug={slug} />,
						search: ({ queryParams: { term } }) => <SearchResults searchTerm={term} />,
						blogPage: ({ params: { slugOrPage: page } }) => {
							return <BlogList page={parseInt(page)} />;
						},
						blogPost: ({ params: { slugOrPage: slug } }) => {
							return <Blog slug={slug} />;
						},
						blog: <BlogList page={1} />,
						error404: <Error404 />
					}}
				</Outlet>
			</main>
			<Footer />
			<GDPRBanner />
		</div>
	);
});

export default App;
